// App actions

export const UPDATE_COMMENT = "PT_UPDATE_COMMENT";
export const UPDATE_STEP = "PT_UPDATE_STEP";
export const TOGGLE_INDICATOR = "PT_TOGGLE_INDICATOR";
export const TOGGLE_APPENDIX_TIP = "PT_TOGGLE_APPENDIX_TIP";
export const UPSERT_SUGGESTED_TIP = "PT_UPSERT_SUGGESTED_TIP";
export const DELETE_SUGGESTED_TIP = "PT_DELETE_SUGGESTED_TIP";
export const TOGGLE_SUGGESTED_TIP = "PT_TOGGLE_SUGGESTED_TIP";
export const RESET_ASSESSMENT = "PT_RESET_ASSESSMENT";

function updateComment(comment, activeSubStep) {
  return {
    type: UPDATE_COMMENT,
    comment,
    activeSubStep
  };
}

// Toggle functions take index (for subsection), key
// Index is not needed for rating
function toggleIndicator(activeSubStep, riskIndex) {
  return {
    type: TOGGLE_INDICATOR,
    activeSubStep,
    riskIndex
  };
}

const upsertSuggestedTip = tipInfo => {
  return {
    type: UPSERT_SUGGESTED_TIP,
    tipInfo
  };
};

// Delete a suggested tip
const deleteSuggestedTip = tipInfo => {
  return {
    type: DELETE_SUGGESTED_TIP,
    tipInfo
  };
};

// Toggle a suggested tip
const toggleSuggestedTip = tipInfo => {
  return {
    type: TOGGLE_SUGGESTED_TIP,
    tipInfo
  };
};

// Toggle a risk-specific tip
const toggleAppendixTip = tipInfo => {
  return {
    type: TOGGLE_APPENDIX_TIP,
    tipInfo
  };
};

function resetAssessment() {
  return {
    type: RESET_ASSESSMENT
  };
}

export {
  toggleIndicator,
  updateComment,
  upsertSuggestedTip,
  deleteSuggestedTip,
  toggleSuggestedTip,
  toggleAppendixTip,
  resetAssessment
};



// WEBPACK FOOTER //
// ./src/pretravel/components/App/action.js